
export class LagermalYearRequestDTO   {

    marknadsomradeId: number;
    produktionsomradeId: number;
    period: string;

    constructor() {
        this.marknadsomradeId = undefined;
        this.produktionsomradeId = undefined;
        this.period = undefined;
    }
}
